import React from 'react';
import {
	Modal,
} from 'react-bootstrap';
import Button, {
	ButtonColor,
} from 'components/button';
import './entryListModal.scss';


interface ItemProps<T> {
	onClick?: (data: T) => void;
	title?: string | JSX.Element;
	description: string | JSX.Element;
	data: T;
}

export const EntryListItem = <T extends any>({
	onClick,
	title,
	description = <em>Ingen beskrivelse</em>,
	data,
}: ItemProps<T>) => {
	const renderContent = () => (
		<>
			<div className="list-modal-body-button-header">
				{title}
			</div>

			<div className="list-modal-body-button-description">
				{description}
			</div>
		</>
	);

	if (!onClick) {
		return (
			<div className="btn">
				{renderContent()}
			</div>
		);
	}

	return (
		<Button
			color={ButtonColor.WHITE}
			onClick={() => {
				onClick(data);
			}}
		>
			{renderContent()}
		</Button>
	);
}

interface Props {

	/*
	 * Function to be called when modal is closed without a selection being made
	 */
	onClose: () => void;

	title: string;

	/**
	 * The children element should be of the component EntryListItem
	 */
	children: (JSX.Element | null) | (JSX.Element | null)[];
}

export const EntryListModal = ({
	title,
	onClose,
	children,
}: Props) => (
	<Modal
		centered
		show={true}
		onHide={onClose}
		className="list-modal"
		contentClassName="list-modal-content"
	>
		<Modal.Header
			className="list-modal-header"
			closeButton
		>
			{title}
		</Modal.Header>
		<Modal.Body
			className="list-modal-body"
		>
			{children}
		</Modal.Body>
		<Modal.Footer className="list-modal-footer" />
	</Modal>
);